import { Link } from 'react-router-dom';
import { ResponseGetTestsList } from './api/getTestsList';
import GaugeChart from './Gauge/GaugeChart';
import LineChart from './Gauge/LineChart';
import { getTitle } from './helper';

type SlideItemProps = {
  type: string;
  title: string;
  levels: {
    [score: number]: {
      title: string;
      color: string;
    };
  };
  data: ResponseGetTestsList;
};

export const SlideItem = ({ type, title, data, levels }: SlideItemProps) => {
  const lastTest = data[data.length - 1];

  const currentLevelTitle = getTitle({ levels, score: lastTest.score });

  const normalizedType = type.toLowerCase();
  const url =
    data.length === 1
      ? `test/${normalizedType}/${data[0].id}`
      : `test/${normalizedType}`;

  return (
    <Link to={url} state={{ data, levels, title }} className="carousel-item">
      <div className="border-card h-[260px] w-[350px] shrink-0 rounded-2xl border px-6 py-4">
        <div className="mb-1 font-semibold">{title}</div>
        <div className="mb-4 text-sm">{currentLevelTitle}</div>
        {data.length === 1 ? (
          <GaugeChart score={data[0].score} type={type} levels={levels} />
        ) : (
          <LineChart data={data} type={type} levels={levels} />
        )}
      </div>
    </Link>
  );
};
